import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { CloseIcon } from 'src/components';

interface CloseOferCTA {
  setShowOfferToFalse: () => void;
  unSelectCarline?: () => void;
}

const CloseDiv = styled.button`
  position: absolute;
  top: 0;
  right: 8vw;
  cursor: pointer;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
`;

export const CloseOferCTA = (props: CloseOferCTA) => {
  const { setShowOfferToFalse, unSelectCarline } = props;

  return (
    <CloseDiv
      onClick={() => {
        setShowOfferToFalse();
        if (unSelectCarline) unSelectCarline();
      }}
    >
      <CloseIcon color="#001E50" />
    </CloseDiv>
  );
};
